<div #toast class="toast" [class]="cssClasses">
    <div class="image-wrapper">
        @switch (icon) {
            @case ('prediction') {
                <img class="image" src="assets/img/side-betting/crystalball.webp" alt="prediction icon"/>
            }
            @case ('ring-point') {
                <img class="image" src="assets/icon/blue-card.svg" alt="ring point icon"/>
            }
            @case ('network') {
                <img class="image" src="assets/img/network/connection-interrupted-red.webp" alt="network icon"/>
            }
        }
    </div>
    <div class="text-wrapper">
        @if (header) {
            <div class="title">{{ header }}</div>
        }
        @if (predictionWon) {
            <div class="prediction-won-wrapper">
                <span class="amount-won">{{ predictionWon.amountWon | numberSuffix }}</span>
                @switch (predictionWon.currency) {
                    @case ('golds') {
                        <img class="currency-image" src="assets/icon/chips/gold_chip.webp" alt="gold"/>
                    }
                    @case ('sweepbucks') {
                        <img class="currency-image" src="assets/img/sweep/money.webp" alt="sweepscoin"/>
                    }
                }
            </div>
        }
        @if (message) {
            <div class="body">{{ message }}</div>
        }
    </div>
    @if (button) {
        <div class="toast-button clickable" (click)="onToastButtonClick()">{{ button.text }}</div>
    } @else {
        <div class="place-holder"></div>
    }
</div>
